// extracted by mini-css-extract-plugin
export default {"root":"IconJamIconsOutlineLogosLinked_root__9HbKV","vector":"IconJamIconsOutlineLogosLinked_vector__lAiEE","icon":"IconJamIconsOutlineLogosLinked_icon__4csTy"};